import type { ReactNode } from 'react';

export const symbol_storm: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M778-80q-11 0-17.5-10.5T758-113q19-61 25.5-125T782-366q-33 95-115.5 151.5T483-158q-85 0-154-40.5T212-306q-48-67-74-154.5T112-641q0-53 6-104.5T140-848q5-14 16-23t26-9q11 0 17.5 10.5T202-847q-18 61-23.5 125t-.5 127q34-96 118-151.5T483-802q85 0 152.5 40.5t115 108Q798-586 823-499.5T848-320q0 54-6 105.5T820-112q-5 14-16 23t-26 9ZM483-220q109 0 184.5-75.5T743-480q0-109-75.5-184.5T483-740q-109 0-184.5 75.5T223-480q0 109 75.5 184.5T483-220Zm106.5-153.5Q633-417 633-480t-43.5-106.5Q546-630 483-630t-106.5 43.5Q333-543 333-480t43.5 106.5Q420-330 483-330t106.5-43.5ZM419-416q-26-26-26-64t26-64q26-26 64-26t64 26q26 26 26 64t-26 64q-26 26-64 26t-64-26Zm64-64Z"
		/>
	</svg>
);
